
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/style-guide",
      function () {
        return require("private-next-pages/style-guide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/style-guide"])
      });
    }
  